import { render, staticRenderFns } from "./AlertDestinationListHeader.vue?vue&type=template&id=110fa4f8&scoped=true&lang=pug"
import script from "./AlertDestinationListHeader.vue?vue&type=script&lang=ts"
export * from "./AlertDestinationListHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110fa4f8",
  null
  
)

export default component.exports